import { render, staticRenderFns } from "./InventorySelectInputWidget.vue?vue&type=template&id=21033600&scoped=true"
import script from "./InventorySelectInputWidget.vue?vue&type=script&lang=js"
export * from "./InventorySelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21033600",
  null
  
)

export default component.exports